import { LD_CLASSES, PRIORITY_CLASSES } from "@/lib/format";

export const LdBadge = ({ colour, text, testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-mono tabular-nums ${LD_CLASSES[colour] || LD_CLASSES.grey}`}
  >
    {text}
  </span>
);

export const StageBadge = ({ label, testId }) => (
  <span
    data-testid={testId}
    className="inline-flex items-center rounded-full border border-border bg-secondary px-2 py-0.5 text-xs font-medium text-secondary-foreground"
  >
    {label}
  </span>
);

export const PriorityBadge = ({ priority, testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs ${PRIORITY_CLASSES[priority] || LD_CLASSES.grey}`}
  >
    {priority}
  </span>
);

export const Mono = ({ children, className = "" }) => (
  <span className={`font-mono tabular-nums ${className}`}>{children}</span>
);

export const Stat = ({ label, value, colour = "grey", testId, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    className={`rounded-lg border p-3 text-left transition-colors hover:brightness-[0.98] ${LD_CLASSES[colour]}`}
  >
    <div className="text-xs opacity-80">{label}</div>
    <div className="mt-1 font-mono text-2xl tabular-nums leading-none">{value}</div>
  </button>
);
